// Code for downloading pdf's 
const downloadLinks = document.querySelectorAll('.download-link');
  downloadLinks.forEach(link => {
    link.addEventListener('click', function(event) {
      event.preventDefault();

      const fullUrl = this.getAttribute('href');
      const urlWithoutQueryString = fullUrl.split('?')[0]; // Split by '?' and take the first part
      const filename = urlWithoutQueryString.substring(urlWithoutQueryString.lastIndexOf('/') + 1);

      fetch(fullUrl)
          .then(response => response.blob())
          .then(blob => {
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.style.display = 'none';
              a.href = url;
              a.download = filename;
              document.body.appendChild(a);
              a.click();
              window.URL.revokeObjectURL(url);
          })
          .catch(error => console.error('Error downloading file:', error));
    });
});